<template>
  <img
    v-if="srcset"
    class="lazyload"
    :class="$style.root"
    data-sizes="auto"
    :data-src="placeholder"
    :data-srcset="srcset"
    :style="`--aspect-ratio: ${aspectRatio};`"
    :alt="alt || filename"
    :data-orientation="orientation"
  >
  <img
    v-else-if="src"
    class="lazyload"
    :class="$style.root"
    :data-src="src"
    :style="`--aspect-ratio: ${aspectRatio};`"
    :alt="alt || filename"
    :data-orientation="orientation"
  >
</template>

<script setup>
import 'lazysizes'

const props = defineProps({
  srcset: {
    type: String,
    required: false
  },
  src: {
    type: String,
    required: true
  },
  width: {
    type: Number,
    required: true
  },
  height: {
    type: Number,
    required: true
  },
  ratio: {
    type: String
  },
  alt: {
    type: String
  },
  filename: {
    type: String,
    required: true
  }
})

const aspectRatio = computed(() => {
  if (props?.ratio) {
    return props.ratio
  } else {
    return props?.width / props?.height || 1
  }
})

const placeholder = 'data:image/svg+xml,%3Csvg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 3508 2480"%3E%3C/svg%3E'

const orientation = computed(() => {
  if (props?.width > props?.height) {
    return 'landscape'
  } else if (props?.width < props?.height) {
    return 'portrait'
  } else {
    return 'square'
  }
})

</script>

<style module>
  .root {
    width: var(--base--image--width, 100%);
    height: var(--base--image--height, auto);
    max-height: var(--base--image--max-height);

    user-select: none;

    object-fit: var(--base--image--object-fit, contain);
    object-position: var(--base--image--object-position, center);

    --max-aspect-ratio: max(var(--aspect-ratio), var(--base--image--max-aspect-ratio, 0));
    aspect-ratio: var(--base--image--aspect-ratio, var(--max-aspect-ratio));

    display: block;
    visibility: hidden;
  }

  .root:global(.lazyloaded) {
    visibility: visible;

    box-shadow: var(--base--image--box-shadow, none);
    background-color: var(--base--image--background-color, none);
  }
</style>
